import { Injectable, inject, PLATFORM_ID } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { isPlatformBrowser } from '@angular/common';

import { Observable} from 'rxjs';

import { environment } from '../../../environments/environments';

export interface LoginRequest {

  email: string;

  password: string;

}

export interface LoginResponse {

  token: string;

}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private platformId =
    inject(PLATFORM_ID);

  private apiUrl = `${environment.apiUrl}/auth`;
  
  constructor(
    private http: HttpClient
  ) {}

  authenticate(
    payload: LoginRequest
  ): Observable<LoginResponse> {

    return this.http.post<LoginResponse>(
      `${this.apiUrl}/login`,
      payload
    );

  }

  saveToken(token: string): void {

    if (
      isPlatformBrowser(this.platformId)
    ) {

      localStorage.setItem(
        'token',
        token
      );

    }

  }

  getToken(): string | null {

    if (
      isPlatformBrowser(this.platformId)
    ) {

      return localStorage.getItem(
        'token'
      );

    }

    return null;

  }

  logout(): void {

    if (
      isPlatformBrowser(this.platformId)
    ) {

      localStorage.removeItem(
        'token'
      );

    }

  }

  isAuthenticated(): boolean {

    return !!this.getToken();

  }

}